@import "../../scss";

.root {
  position: absolute;
  bottom: var(--spacer-4);
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  width: 13.5rem;
  white-space: nowrap;
  background: var(--color-bright-green);
  border-radius: 111px;
  height: 2.25rem;
  padding: 0 1rem;
  color: var(--color-white);
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border: none;
  @include typo--button();
}

.root > svg {
  height: 1.375rem;
  width: auto;
  margin-right: 0.6rem;
  flex-shrink: 0;
}
